import { IPointsMallCouponItem } from '@/api/types/account';
import GoodsDetailCollapse from '@/components/GoodsDetail/GoodsDetailCollapse';
import { Box } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';

export default function RedemptionTerms({ couponInfo }: { couponInfo: IPointsMallCouponItem }) {
  const t = useTranslations('account.pointsMall.redemptionTerms');

  return (
    <GoodsDetailCollapse title={t('title')} defaultOpen>
      <Box className="mb-24">
        <p className="text-14 leading-[21px] font-ir">
          {Number(couponInfo.restrict_details) > 0
            ? t('terms.limitedRedemptions', { limit: couponInfo.restrict_details.toString() })
            : t('terms.unlimited')}
        </p>
        <p className="text-14 mt-16 leading-[21px] font-ir">{t('terms.limitedQuantity')}</p>
        <p className="text-14 mt-16 leading-[21px] font-ir">{t('terms.noReturn')}</p>
      </Box>
    </GoodsDetailCollapse>
  );
}
